import React from 'react';
import {withStyles} from '@material-ui/core/styles';


function CloseButton(props) {
  const {classes, className, ...otherProps} = props;
  return (
    <div className={`${classes.button} ${className}`} {...otherProps}>
      ✕
    </div>
  );
}

export default withStyles((theme) => ({
  button: {
    color: theme.palette.secondary.dark,
    ...theme.typography.hg24r(theme),
    lineHeight: '1em',
    cursor: 'pointer',
  }
}))(CloseButton);




// WEBPACK FOOTER //
// ./src/parts/CloseButton.js